import React from 'react';
import { Typography, Box, IconButton } from '@material-ui/core';
import {
  FileCopyOutlined as FileCopyOutlinedIcon,
  GetApp as DownloadIcon,
  Check as CheckIcon,
} from '@material-ui/icons';
import { useSelector } from 'react-redux';

const LinkAndQRCodeWidget = ({
  currentSurvey,
  assessmentStatus,
  generatedLink,
  linkCopied,
  qrRef,
  copyLinkToClipboard,
  downloadQR,
  classes,
}) => {
  const { en: { instantSurvey } } = useSelector((state) => state.i18n);

  if (!currentSurvey) return null;

  return (
    <div className={`${classes.section} ${classes.previewSection} ${assessmentStatus === 'archived' ? classes.sectionArchived : ''}`}>
      <Typography className={classes.sectionTitle}>
        {instantSurvey.linkQrCodeTitle}
      </Typography>
      <div className={classes.sectionContent}>
        <Box display="flex" flexDirection="column" alignItems="center">
          {/* Survey Access Section */}
          <Box width="100%" textAlign="center" mb={3}>
            <Typography variant="h6" style={{
              color: '#666',
              marginBottom: 12,
              fontSize: '1rem',
              fontWeight: 500,
            }}>
              {instantSurvey.sectionSurveyLink}
            </Typography>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <Box className={classes.linkContainer}>
                <Typography className={classes.linkText}>{generatedLink}</Typography>
                <IconButton onClick={copyLinkToClipboard} className={classes.linkCopyButton} size="small">
                  {linkCopied ? (
                    <CheckIcon className={classes.linkCopyIcon} />
                  ) : (
                    <FileCopyOutlinedIcon className={classes.linkCopyIcon} />
                  )}
                </IconButton>
              </Box>
            </div>
          </Box>

          {/* Visual Divider */}
          <Box
            width="100%"
            height="1px"
            bgcolor="#e0e0e0"
            my={1}
          />

          {/* Mobile Access Section */}
          <Box width="100%" textAlign="center">
            <Typography variant="h6" style={{
              color: '#666',
              marginBottom: 12,
              fontSize: '1rem',
              fontWeight: 500,
            }}>
              {instantSurvey.sectionQrCode}
            </Typography>
            <div className={classes.qrSection}>
              <div className={classes.downloadButton} />
              <div className={`${classes.qrContainer} ${assessmentStatus === 'archived' ? 'archived' : ''}`}>
                <div ref={qrRef} />
              </div>
              <IconButton
                onClick={downloadQR}
                className={classes.downloadButton}
                aria-label={instantSurvey.downloadQrAriaLabel}
              >
                <DownloadIcon fontSize="inherit" />
              </IconButton>
            </div>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default LinkAndQRCodeWidget;
